export const CompanyApiUrls = {
  createCompany: "company/CreateCompany",
  updateCompany: "company/UpdateCompany",
  deleteCompany: "company/DeleteCompany",
  getCompanyById: "company/GetCompanyById",
  getAllCompanies: "company/GetAllCompanies",
  updateIsArchive: "Company/UpdateIsArchive",
};

export default class CompanyAPI {
  constructor(httpsClient, cache) {
    this.httpsClient = httpsClient;
    this.cache = cache;
  }

  async createCompany(data, token) {
    return this.post(CompanyApiUrls.createCompany, data, token, true, true);
  }

  async deleteCompany(data, token) {
    return this.get(CompanyApiUrls.deleteCompany, data, token, true, true);
  }

  async updateCompany(data, token) {
    return this.post(CompanyApiUrls.updateCompany, data, token, true, true);
  }

  async getAllCompanies(data, token) {
    return this.get(CompanyApiUrls.getAllCompanies, data, token);
  }

  async getCompanyById(data, token) {
    return this.get(CompanyApiUrls.getCompanyById, data, token);
  }

  async updateIsArchive(data, token) {
    return this.get(CompanyApiUrls.updateIsArchive, data, token, true, true);
  }

  async get(url, data, token, eAlert, sAlert) {
    const response = await this.httpsClient.get(url, data, token, eAlert, sAlert);

    return response;
  }

  async post(url, data, token, eAlert, sAlert) {
    this.cache.remove("tests");

    return await this.httpsClient.post(url, data, token, eAlert, sAlert);
  }
}
